import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { StickyContactBar } from "@/components/StickyContactBar";
import Home from "@/pages/Home";
import ServicesIndex from "@/pages/ServicesIndex";
import ServicePage from "@/pages/ServicePage";
import CitiesIndex from "@/pages/CitiesIndex";
import CityPage from "@/pages/CityPage";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Careers from "@/pages/Careers";
import ComboPage from "@/pages/ComboPage";
import QuebecHome from "@/pages/QuebecHome";
import QuebecServices from "@/pages/QuebecServices";
import QuebecCityPage from "@/pages/QuebecCityPage";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import { SERVICES } from "@/data/services";
import { CITIES } from "@/data/cities";
import { QC_CITIES, QC_ON_CITIES, qcCityPath, qcOnCityPath } from "@/data/quebec";
import { POSTS } from "@/data/posts";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const NormalizeUrl = () => {
  const { pathname, search, hash } = useLocation();
  const cleanPath = pathname !== "/" && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
  if (cleanPath !== pathname || search) {
    return <Navigate to={`${cleanPath}${hash}`} replace />;
  }
  return null;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-[#0B0F17] text-slate-100">
        <BrowserRouter>
          <NormalizeUrl />
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/security-services" element={<ServicesIndex />} />
              {SERVICES.map((s) => (
                <Route key={s.slug} path={`/security-services/${s.slug}`} element={<ServicePage service={s} />} />
              ))}
              <Route path="/ontario-service-areas" element={<CitiesIndex />} />
              {CITIES.map((c) => (
                <Route key={c.slug} path={`/security-guards-${c.slug}-ontario`} element={<CityPage city={c} />} />
              ))}
              <Route path="/about-1st-nations-security" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/on/:citySlug/:serviceSlug" element={<ComboPage />} />
              <Route path="/qc" element={<QuebecHome />} />
              <Route path="/qc/services-de-securite" element={<QuebecServices />} />
              {QC_CITIES.map((q) => (
                <Route key={q.slug} path={`/qc/villes/${q.slug}`} element={<QuebecCityPage city={q} allCities={QC_CITIES} pathFn={qcCityPath} />} />
              ))}
              {QC_ON_CITIES.map((q) => (
                <Route key={q.slug} path={`/qc/ontario/${q.slug}`} element={<QuebecCityPage city={q} allCities={QC_ON_CITIES} pathFn={qcOnCityPath} province="Ontario" />} />
              ))}
              <Route path="/security-blog" element={<BlogIndex />} />
              {POSTS.map((p) => (
                <Route key={p.slug} path={`/security-blog/${p.slug}`} element={<BlogPost post={p} />} />
              ))}
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <StickyContactBar />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
